import { CHAT_MESSAGES } from '../components/chat/config/chatMessages'
import { getLocalizedProductText } from '../components/chat/utils/productHelpers'

const useCameraStep = ({
  predictHairAttributes,
  saveAnswer,
  upsertDerivedAnswer,
  dispatch,
  setPhotoPreview,
  setHairNeedsRetry,
  setHairRetryCount,
  hairPredictionRetryCount,
  addAiMessage,
  goToStepById,
  goToNextStep,
  translations = {},
  language = 'EN',
}) => {
  const handleCameraStep = async (step, photoUrl) => {
    saveAnswer({
      step,
      text: null,
      photoUrl,
      extractedValue: photoUrl,
      value: photoUrl,
      isValid: true,
      attempt: 1,
    })

    const hairPrediction = await predictHairAttributes(photoUrl)

    if (hairPrediction.maskedImage) {
      dispatch(setPhotoPreview(hairPrediction.maskedImage))

      addAiMessage({
        text: getLocalizedProductText({
          translations,
          language,
          keyPath: 'chatMessages.segmentedHairImage',
          fallback: CHAT_MESSAGES.segmentedHairImage,
        }),
        photoUrl: hairPrediction.maskedImage,
      })

      upsertDerivedAnswer('segmentedHairImage', hairPrediction.maskedImage)
    }

    upsertDerivedAnswer(
      'predictedHairClass',
      hairPrediction?.predictedHairClass,
    )

    upsertDerivedAnswer('hairPrediction', {
      predictedHairClass: hairPrediction?.predictedHairClass,
      predictedHairDescription: hairPrediction?.predictedHairDescription,
    })

    if (hairPrediction?.predictedHairClass === 'Unknown') {
      if (hairPredictionRetryCount < 1) {
        dispatch(setHairNeedsRetry(true))

        addAiMessage({
          text: getLocalizedProductText({
            translations,
            language,
            keyPath: 'chatMessages.hairPredictionRetry',
            fallback: CHAT_MESSAGES.hairPredictionRetry,
          }),
        })

        return
      }

      dispatch(setHairNeedsRetry(false))
      dispatch(setHairRetryCount(0))

      addAiMessage({
        text: getLocalizedProductText({
          translations,
          language,
          keyPath: 'chatMessages.hairPredictionManualSelection',
          fallback: CHAT_MESSAGES.hairPredictionManualSelection,
        }),
      })

      goToStepById('hair_prediction_corrected_value', true)

      return
    }

    dispatch(setHairNeedsRetry(false))
    dispatch(setHairRetryCount(0))

    goToNextStep(step.id)
  }

  return {
    handleCameraStep,
  }
}

export default useCameraStep
